/**
 * Collect browser metadata from the user agent string.
 * Shared utility used by report-tracking and thought-bubble-runtime.
 */
export function getBrowserMeta(): Record<string, string> {
  const ua = navigator.userAgent;
  return {
    device_type: /Mobi|Android/i.test(ua) ? 'mobile' : 'desktop',
    os: detectOS(ua),
    browser_name: detectBrowser(ua),
    browser_version: detectBrowserVersion(ua),
  };
}

function detectOS(ua: string) {
  if (ua.includes('Windows')) return 'Windows';
  if (ua.includes('Android')) return 'Android';
  if (/iPhone|iPad|iPod/.test(ua)) return 'iOS';
  if (ua.includes('Mac OS')) return 'macOS';
  if (ua.includes('Linux')) return 'Linux';
  return 'Unknown';
}

function detectBrowser(ua: string) {
  if (ua.includes('Edg/')) return 'Edge';
  if (ua.includes('Chrome') && !ua.includes('Edg/')) return 'Chrome';
  if (ua.includes('Firefox')) return 'Firefox';
  if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
  return 'Unknown';
}

function detectBrowserVersion(ua: string) {
  const patterns: [string, RegExp][] = [
    ['Edge', /Edg\/(\d+[\d.]*)/],
    ['Chrome', /Chrome\/(\d+[\d.]*)/],
    ['Firefox', /Firefox\/(\d+[\d.]*)/],
    ['Safari', /Version\/(\d+[\d.]*)/],
  ];
  for (const [, regex] of patterns) {
    const match = ua.match(regex);
    if (match?.[1]) return match[1];
  }
  return 'Unknown';
}
